import { initClient, initClientNavigation } from "rwsdk/client";
import { initializeAnalytics, trackPageView } from "./utils/analytics.client";

const { handleResponse } = initClientNavigation();
initClient({ handleResponse });
initializeAnalytics();
trackPageView();
